(function(w){'use strict';
var MAX=30,TITLE_MAX=15,NAME_MAX=15,BG=['Cream','Blush','Forest Green','Christmas Red','Chocolate','Navy'];
function clean(s){return String(s==null?'':s).replace(/\s+/g,' ').trim();}
// s = {bg:'Cream', title:'Grandma', count:'3', names:['A','B','C']}
function missing(s){
 var m=[];
 if(BG.indexOf(s.bg)<0)m.push('bg');
 if(!clean(s.title))m.push('title');
 var n=parseInt(s.count,10);
 if(!(n>=1&&n<=MAX))m.push('count');
 else for(var i=0;i<n;i++)if(!clean((s.names||[])[i]))m.push('name'+i);
 return m;
}
function props(s){
 if(missing(s).length)throw Error('Please complete your personalization.');
 var n=parseInt(s.count,10),p={};
 if(clean(s.title).length>TITLE_MAX)throw Error('Custom Title is limited to '+TITLE_MAX+' characters.');
 p['Background Color']=s.bg;
 p['Custom Title']=clean(s.title);
 p['Number Of Names']=String(n);
 for(var i=0;i<n;i++){
  var v=clean(s.names[i]);
  if(v.length>NAME_MAX)throw Error('Each name is limited to '+NAME_MAX+' characters.');
  p['Custom Name #'+(i+1)]=v;
 }
 return p;
}
function apply(payload,s,ids){
 var items=(payload.items||[payload]).map(function(i){return Object.assign({},i);}),p=props(s);
 items.forEach(function(i){if(ids.indexOf(String(i.id))>=0)i.properties=Object.assign({},i.properties,p);});
 var out=payload.items?Object.assign({},payload):{};out.items=items;return out;
}
w.NPCore={MAX:MAX,TITLE_MAX:TITLE_MAX,NAME_MAX:NAME_MAX,BG:BG,clean:clean,missing:missing,props:props,apply:apply};
})(typeof window==='undefined'?globalThis:window);
